import { DoctorRepository } from '../contracts/repositories';
import { Doctor } from '../entities';

export class DoctorService {
  constructor(private readonly doctorRepository: DoctorRepository) {}

  async listAll(): Promise<Doctor[]> {
    return await this.doctorRepository.findAll();
  }

  async listForAppointment({
    specialtyCode,
    medicalCenter,
    currentDate
  }: {
    specialtyCode: string;
    medicalCenter: string;
    currentDate: Date;
  }): Promise<Doctor[]> {
    return await this.doctorRepository.find({ specialtyCode, medicalCenter, currentDate });
  }

  async findOne(doctorId: string) {
    return await this.doctorRepository.findOne(doctorId);
  }

  async updateAvailableDays(doctorId: string, availableDays: number[]) {
    console.log(availableDays);
    return await this.doctorRepository.updateAvailableDays(doctorId, availableDays);
  }

  async create(doctor: Doctor) {
    await this.doctorRepository.create(doctor);
  }
}
